module.exports = __webpack_public_path__ + "img/multi_vendor_orders_1.2cd4a3ce.png";